import { useProfile } from "@reflexjs/gatsby-theme-profile";
import * as React from 'react';
export default {
  useProfile,
  React
};